import "./PresentationPage.css";
import presentationPdf from "../../GivvyOffersPresentation.pdf";

export default function PresentationPage({ onBack }) {
  return (
    <div className="presentation-page">
      <iframe
        className="presentation-page__iframe"
        title="Givvy Offers Presentation"
        src={presentationPdf}
      />
      <div className="presentation-page__actions">
        <a className="presentation-page__link" href={presentationPdf} target="_blank" rel="noreferrer">
          Open PDF
        </a>
        {onBack ? (
          <button className="presentation-page__back" type="button" onClick={onBack}>
            Back
          </button>
        ) : null}
      </div>
    </div>
  );
}
